<template>
  <b-modal id="downloadModal" hide-footer centered>
    <template #modal-header>
      <b-button size="sm" class="close" @click="closeModal">×</b-button>
    </template>
    <div class="text-center">
      <div class="bg-primary mb-2">
        <img src="@/assets/images/icons/xlsx.png" alt="XLSX Icon" class="my-2" />
      </div>
      <p>
        <b>{{ dateRangeMessage }}</b>
      </p>
      <p>{{ t('You are downloading shipment data between the selected dates.') }}</p>
      <p>
        {{ t('Depending on the selected date range, the download process may take some time.') }}
      </p>
      <p>{{ t('Closing the page or switching tabs will not affect the download.') }}</p>
      <p>
        {{
          t(
            'Once the download is complete, you can access and re-download the data from the "Export List" page.'
          )
        }}
      </p>

      <div class="d-flex justify-content-center mb-3 text-center">
        <b-form-radio-group
          v-model="selectedFormat"
          name="exportFormat"
          class="list-radio-group"
          size="sm"
        >
          <b-form-radio :value="'application/excel'">Excel</b-form-radio>
          <b-form-radio :value="'text/csv'">CSV</b-form-radio>
        </b-form-radio-group>
      </div>

      <b-button variant="primary" @click="confirmDownload"
        >{{ t('Download Consignment Data') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BButton, BFormRadioGroup, BFormRadio } from 'bootstrap-vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n';

export default {
  props: {
    startDate: { type: String, required: true },
    endDate: { type: String, required: true }
  },
  data() {
    return {
      selectedFormat: 'application/excel'
    };
  },
  computed: {
    dateRangeMessage() {
      return `${this.startDate} - ${this.endDate}`;
    }
  },
  components: {
    BButton,
    BModal,
    BFormRadioGroup,
    BFormRadio
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('downloadModal');
    },
    confirmDownload() {
      this.$emit('confirm-download', { export_format: this.selectedFormat });
      this.closeModal();
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>
